import * as React from 'react';
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps';
import { mapDotIcon } from 'utils/mapsUtils';

interface Props {
  position: google.maps.LatLngLiteral;
}

/**
 * vis.gl (flag-ON) current-location dot. Renders the same SVG produced by
 * {@link mapDotIcon} as `<AdvancedMarker>` content, center-anchored to match the
 * legacy `google.maps.Icon` anchor (`scaledSize * 0.5`).
 */
const ConsumerLocationDotNew: React.FunctionComponent<Props> = ({ position }) => {
  const color1 = 'rgba(66,133,244,0.3)';
  const color2 = '#FFF';
  const color3 = 'rgba(66,133,244,1)';
  const dotSize = 40;
  const icon = mapDotIcon(dotSize, color1, color2, color3);

  return (
    <AdvancedMarker position={position} anchorPoint={AdvancedMarkerAnchorPoint.CENTER}>
      <img src={icon.url} width={dotSize} height={dotSize} alt="" />
    </AdvancedMarker>
  );
};

export default ConsumerLocationDotNew;
